export default {
  breadcrumbAriaLabel: {
    id: 'outlet_breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb navigation',
  },
  home: {
    id: 'outlet_breadcrumb_home',
    defaultMessage: 'Home',
  },
  outletHome: {
    id: 'outlet_breadcrumb_outlet_home',
    defaultMessage: 'Outlet',
  },
}
